import dayjs from 'dayjs';

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function time_format(time, format) {
  return dayjs(time).format(format || TIME_FORMAT);
}
